import React from 'react';

export const LocationIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 22"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#727272" fillRule="nonzero">
        <g>
          <path
            d="M27.475 9.304L14.495.35c-.29-.204-.7-.204-.99 0L.524 9.304c-.408.263-.496.788-.233 1.196l.525.758c.116.205.32.321.554.35.233.03.466 0 .642-.146l1.283-.874v10.704c0 .379.32.7.7.7h1.283c.38 0 .7-.321.7-.7V8.896c0-.088.03-.146.088-.175l7.816-5.396c.088-.058.175-.058.263 0l7.816 5.396c.059.029.088.117.088.175v12.396c0 .379.32.7.7.7h1.283c.38 0 .7-.321.7-.7V10.617l1.284.875c.379.262.933.175 1.195-.234l.496-.758c.117-.204.175-.408.146-.642-.058-.233-.175-.437-.379-.554z"
            transform="translate(-308 -299) translate(308 299)"
          />
          <path
            d="M12.863 16.508h-1.605v.963H9.975v-.963H8.371c-.263 0-.496.204-.496.496v4.492c0 .262.204.496.496.496h4.492c.262 0 .495-.204.495-.496v-4.492c0-.292-.233-.496-.495-.496zM11.754 9.742c-.262 0-.496.204-.496.495v4.492c0 .263.205.496.496.496h4.492c.262 0 .496-.204.496-.496v-4.491c0-.263-.204-.496-.496-.496h-1.604v.962h-1.284v-.962h-1.604zM19.63 16.508h-1.605v.963h-1.283v-.963h-1.605c-.262 0-.495.204-.495.496v4.492c0 .262.204.496.495.496h4.492c.263 0 .496-.204.496-.496v-4.492c0-.292-.233-.496-.496-.496z"
            transform="translate(-308 -299) translate(308 299)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default LocationIcon;
